const themeColors = {
    primary: '#4d7df2',
    secondary: '#4d7df2',
    success: '#00d41a',
    info: '#00d0bd',
    warning: '#ffb70f',
    error: '#e53935',
    textPrimary: '#ffffff',
    textSecondary: '#717275',
    divider: 'rgba(255,255,255,0.12)',
    icon: '#717275',
    bgPaper: '#27293c',
    bgDefault: '#1e1e2e',
    white: '#ffffff',
    black: '#000000',
};
  
export default themeColors;